import { render, staticRenderFns } from "./BillMain.vue?vue&type=template&id=2fc6a999&scoped=true"
import script from "./BillMain.vue?vue&type=script&lang=js"
export * from "./BillMain.vue?vue&type=script&lang=js"
import style0 from "./BillMain.vue?vue&type=style&index=0&id=2fc6a999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc6a999",
  null
  
)

export default component.exports